<template>
  <div
    class="min-h-screen flex flex-col py-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
  >
    <div class="max-w-2xl mx-auto w-full py-10">
      <router-link
        to="/open"
        class="inline-flex items-center text-white/80 hover:text-white text-sm font-medium mb-6 transition-colors"
      >
        ← Back
      </router-link>

      <div class="support-content text-white/90 space-y-3">
        <h1 class="text-2xl sm:text-3xl font-bold text-white mb-6">Support</h1>

        <!-- Contact email -->
        <section>
          <h2 class="text-lg font-semibold text-white mt-8 mb-2 flex items-center gap-2">
            <span aria-hidden="true">📧</span> Contact
          </h2>
          <p class="text-white/80 leading-relaxed mb-2">
            For technical support, questions, or feedback, send us an email:
          </p>
          <a
            href="mailto:madproject.corp@gmail.com"
            class="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-medium transition-colors"
          >
          madproject.corp@gmail.com
          </a>
        </section>

        <!-- Response time -->
        <section>
          <h2 class="text-lg font-semibold text-white mt-8 mb-2 flex items-center gap-2">
            <span aria-hidden="true">⏱</span> Response time
          </h2>
          <p class="text-white/80 leading-relaxed">
            We aim to respond to all requests within <strong class="text-white">48 hours</strong> on business days (Monday–Friday). For urgent issues, please mention "Urgent" in your email subject.
          </p>
        </section>

        <!-- FAQ -->
        <section>
          <h2 class="text-lg font-semibold text-white mt-8 mb-2 flex items-center gap-2">
            <span aria-hidden="true">🛠</span> FAQ
          </h2>
          <div class="space-y-4 mt-4">
            <div>
              <p class="font-medium text-white mb-1">How do I cancel my subscription?</p>
              <p class="text-white/80 leading-relaxed text-sm">
                On <strong class="text-white">iOS</strong>: Settings → [Your Name] → Subscriptions → EpicFace → Cancel. On <strong class="text-white">Android</strong>: Google Play Store → Menu → Subscriptions → EpicFace → Cancel. Cancellation takes effect at the end of your current billing period.
              </p>
            </div>
            <div>
              <p class="font-medium text-white mb-1">Is my face data stored?</p>
              <p class="text-white/80 leading-relaxed text-sm">
                No. Uploaded photos are used only to generate your image and are <strong class="text-white">permanently deleted</strong> once the generation is complete. We do not keep copies of your face data. See our <router-link to="/privacy" class="text-yellow-400 hover:text-yellow-300">Privacy Policy</router-link> for details.
              </p>
            </div>
            <div>
              <p class="font-medium text-white mb-1">How do I request a refund?</p>
              <p class="text-white/80 leading-relaxed text-sm">
                Refunds are handled by the store: <strong class="text-white">Apple</strong> — <a href="https://reportaproblem.apple.com" target="_blank" rel="noopener noreferrer" class="text-yellow-400 hover:text-yellow-300">reportaproblem.apple.com</a>; <strong class="text-white">Google</strong> — Google Play Help (Subscriptions &amp; refunds).
              </p>
            </div>
            <div>
              <p class="font-medium text-white mb-1">I didn’t find my question here.</p>
              <p class="text-white/80 leading-relaxed text-sm">
                Email us at <a href="mailto:madproject.corp@gmail.com" class="text-yellow-400 hover:text-yellow-300">madproject.corp@gmail.com</a> and we’ll get back to you as soon as possible.
              </p>
            </div>
          </div>
        </section>

        <!-- Account / data deletion -->
        <section>
          <h2 class="text-lg font-semibold text-white mt-8 mb-2 flex items-center gap-2">
            <span aria-hidden="true">🗑</span> Account and data deletion
          </h2>
          <p class="text-white/80 leading-relaxed mb-3">
            You can request deletion of your personal data and, where applicable, your account at any time.
          </p>
          <ol class="list-decimal pl-6 space-y-2 text-white/80 text-sm mb-4">
            <li>Send an email to <a href="mailto:madproject.corp@gmail.com" class="text-yellow-400 hover:text-yellow-300">madproject.corp@gmail.com</a> with the subject <strong class="text-white">"Data deletion request"</strong> (or "Account deletion request" if you have an account).</li>
            <li>Include the email address associated with your account or the one you used when contacting us, so we can identify your data.</li>
            <li>We will process your request within 30 days and confirm once your data has been deleted.</li>
          </ol>
          <p class="text-white/80 leading-relaxed text-sm">
            For more on what we collect and how long we keep it, see our <router-link to="/privacy" class="text-yellow-400 hover:text-yellow-300">Privacy Policy</router-link> (sections "Retention of Your Personal Data" and "Your Rights").
          </p>
        </section>

        <!-- Privacy Policy link -->
        <section>
          <h2 class="text-lg font-semibold text-white mt-8 mb-2">Privacy &amp; legal</h2>
          <p class="text-white/80 leading-relaxed mb-2">
            For how we collect, use and protect your data:
          </p>
          <router-link
            to="/privacy"
            class="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-medium transition-colors"
          >
            🔗 Privacy Policy
          </router-link>
          <p class="text-white/80 leading-relaxed mt-2 text-sm">
            For terms of use, see our <router-link to="/terms" class="text-yellow-400 hover:text-yellow-300">Terms and Conditions</router-link>.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
